import styled from 'styled-components/native'

export const RightActionContainer = styled.View`
  flex-direction: row;
  min-width: 160px;
`
